import "core-js/stable";
import "regenerator-runtime/runtime";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/store";
import mitt from "mitt";
import axios from "axios";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { md3 } from "vuetify/blueprints";
import VueCookies from "vue3-cookies";
import VueGtag from "vue-gtag";
import vClickOutside from "click-outside-vue3"
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import VueForceNextTick from 'vue-force-next-tick'
import { VStepperVertical } from 'vuetify/labs/VStepperVertical'
import EventService from '@/services/EventService.js'; // Importuj EventService

const app = createApp(App);
const emitter = mitt();

const vuetify = createVuetify({
  components: {
    ...components,
    VStepperVertical,
  },
  directives,
  blueprint: md3,
});

EventService.setEmitter(emitter);
app.config.globalProperties.emitter = emitter;
app.use(router);
app.use(
  VueGtag,
  {
    config: { id: "G-EBQP3H6W4F" },
  },
  router
);
app.use(store);
app.use(vuetify);
app.use(vClickOutside);
app.use(VueForceNextTick);

const userStringLS = localStorage.getItem("user-muzible");
if (userStringLS) {
  const userDataLS = JSON.parse(userStringLS);
  store.dispatch("checkJWTValid", userDataLS).then(({ data }) => {
    if (data.jwtinvalid === 1) {
      store.dispatch("logout");
   } else {
      store.commit("SET_USER_DATA_LS", userDataLS);
      // Only place where we set_cookies manually, otherwise cookies are taken from server during login/register/auth2fa
      store.commit("SET_COOKIES", userDataLS);
      router.push({ name: "plan" });
    }
  })
  .catch((error) => {
    if (!error.response) {
      store.dispatch("logout");
    }
  });
}



app.config.globalProperties.axios = axios;
app.mixin({
  created() {

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          this.$store.dispatch("logout");
        }
        return Promise.reject(error);
      }
    );
  },
});

app.mount("#app");
